module.exports = __webpack_public_path__ + "static/media/thunder_storm.1124477a.gif";